import styled from 'styled-components';
export const SortableContainer = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
  padding-left: 14px;

  > div {
    flex: 1;
  }

  > button {
    border: none;
    background: none;
    cursor: move;
  }
`;